import { render } from "./DepartmentDetail.vue?vue&type=template&id=5d786a3f"
import script from "./DepartmentDetail.vue?vue&type=script&lang=js"
export * from "./DepartmentDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\leeten-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__